import { getCurrentInstance } from 'vue'

export function useStore() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('Should be used in setup().')
  }
  return instance.proxy.$store
}
